import styled, { css } from 'styled-components';
import Left from 'prizm-icons/lib/16px/Navigation/Chevron/Left';
import Right from 'prizm-icons/lib/16px/Navigation/Chevron/Right';

export const Filter = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${({ theme }) => theme.lpbDashboard.colors.filterBg};
  border-bottom: 1px solid ${({ theme }) => theme.lpbDashboard.colors.filterBorder};
  padding: ${({ theme }) => theme.lpbDashboard.filterPanel.containerPadding};
`;

export const FilterItems = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: ${({ theme }) => theme.lpbDashboard.filterPanel.linksAligment};
  overflow-x: hidden;

  ${({ withArrows }) => withArrows && css`
    justify-content: flex-start;
  `}
`;

export const FilterLink = styled.span`
  cursor: pointer;
  display: block;
  font-size: 14px;
  font-weight: 300;
  color: ${({ theme }) => theme.lpbDashboard.colors.filterLinkColor};
  line-height: 16px;
  position: relative;
  padding: 16px 0;
  margin: 0 16px;
  flex-shrink: 0;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  ${({ active }) => active && css`
    color: ${({ theme }) => theme.lpbDashboard.colors.filterLinkActive};

    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 3px;
      width: 100%;
      background-color: ${({ theme }) => theme.lpbDashboard.colors.filterLinkActive};
    }
  `}
`;

export const Arrows = styled.div`
  background-color: ${({ theme }) => theme.lpbDashboard.colors.filterArrowsBg};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  width: 96px;
`;

export const Lshevron = styled(Left)`
  fill: ${({ theme }) => theme.lpbDashboard.colors.filterArrowColor};
  cursor: pointer;
`;

export const Rshevron = styled(Right)`
  fill: ${({ theme }) => theme.lpbDashboard.colors.filterArrowColor};
  cursor: pointer;
`;
